import React from 'react'
import useMobile from '../../hooks/useMobile'
import IssueManagementDesktop from './IssueManagementDesktop'
import { useIssueManagement } from './hooks/useIssueManagement'
import IssueMobileView from './components/IssueMobileView'

const IssueManagement = () => {
    const isMobile = useMobile()
    const logic = useIssueManagement()

    if (isMobile) {
        return <IssueMobileView logic={logic} />
    }

    return <IssueManagementDesktop logic={logic} />
}

export default IssueManagement
